exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-csv input{position:absolute;left:0;margin:0;padding:0;width:100%;height:190px;outline:none;opacity:0}.csv-text{margin-top:10%}.form-csv{height:200px;border:4px dashed #c6c7c7;background-color:#eceff0}", ""]);

// exports
